module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_6.c5aed22c.png";